module.exports = {
  TRANSPORT_MODE_SELECTED: 'TRANSPORT_MODE_SELECTED',
  ALL_TRANSPORT_MODES_SELECTED: 'ALL_TRANSPORT_MODES_SELECTED',
  ALL_TRANSPORT_MODES_DE_SELECTED: 'ALL_TRANSPORT_MODES_DE_SELECTED',
};
